export default __webpack_public_path__ + "static/media/psyduckPainted.995261cb.glb";